import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  es: {
    translation: {
      brand: "DocuConvert",
      tagline: "Convierte y firma documentos sin pretextos.",
      hero_eyebrow: "Plataforma de documentos",
      hero_title_1: "Cualquier formato.",
      hero_title_2: "Cualquier dirección.",
      hero_sub:
        "PDF, Word, Excel, PowerPoint, HTML, imágenes y mucho más. Convierte, fusiona, divide y firma en segundos. Tus archivos. Tu control.",
      cta_start: "Empezar gratis",
      cta_login: "Iniciar sesión",
      cta_register: "Crear cuenta",
      cta_logout: "Cerrar sesión",
      cta_dashboard: "Mi panel",
      cta_download: "Descargar",
      cta_delete: "Eliminar",
      cta_continue: "Continuar",
      cta_convert: "Convertir",
      cta_back: "Volver",
      cta_choose_file: "Elegir archivo",
      cta_choose_files: "Elegir archivos",
      cta_drop_here: "Suelta el archivo aquí",
      cta_clear: "Limpiar",
      cta_save: "Guardar",
      cta_apply: "Aplicar",
      // Nav
      nav_tools: "Herramientas",
      nav_convert: "Convertir",
      nav_pdf: "PDF Tools",
      nav_dashboard: "Panel",
      // Tools
      tools_title: "Herramientas",
      tools_subtitle: "Todas las operaciones que necesitas en un solo lugar.",
      tool_convert: "Convertir documento",
      tool_convert_desc: "Cambia entre PDF, Word, Excel, HTML, imágenes y más.",
      tool_merge: "Fusionar PDFs",
      tool_merge_desc: "Une múltiples PDFs en un único archivo en orden.",
      tool_split: "Dividir PDF",
      tool_split_desc: "Separa un PDF en una página por archivo.",
      tool_extract: "Extraer páginas",
      tool_extract_desc: "Selecciona páginas específicas y guárdalas como nuevo PDF.",
      tool_reorder: "Reordenar páginas",
      tool_reorder_desc: "Arrastra y reorganiza páginas dentro de un PDF.",
      tool_sign: "Firmar PDF",
      tool_sign_desc: "Dibuja tu firma y colócala en cualquier página.",
      tool_annotate: "Añadir texto",
      tool_annotate_desc: "Inserta anotaciones de texto en cualquier coordenada.",
      // Auth
      auth_login_title: "Bienvenido de vuelta",
      auth_login_sub: "Accede para gestionar tus documentos.",
      auth_register_title: "Crea tu cuenta",
      auth_register_sub: "Sin tarjeta. Sin spam. Solo herramientas.",
      auth_email: "Correo electrónico",
      auth_password: "Contraseña",
      auth_name: "Nombre",
      auth_no_account: "¿No tienes cuenta?",
      auth_have_account: "¿Ya tienes cuenta?",
      auth_loading: "Cargando…",
      // Dashboard
      dashboard_title: "Mis documentos",
      dashboard_subtitle: "Historial de archivos subidos y resultados generados.",
      dashboard_empty: "Aún no tienes archivos. Empieza convirtiendo o usando una herramienta.",
      th_name: "Nombre",
      th_kind: "Tipo",
      th_op: "Operación",
      th_size: "Tamaño",
      th_date: "Fecha",
      th_actions: "Acciones",
      kind_upload: "Subido",
      kind_converted: "Convertido",
      kind_tool_output: "Salida",
      // Conversion
      convert_title: "Conversor universal",
      convert_subtitle: "Selecciona un archivo y elige a qué formato quieres convertirlo.",
      convert_target: "Convertir a",
      convert_done: "Conversión lista",
      // PDF tools page
      pdf_pages_loading: "Cargando páginas…",
      pdf_select_pages: "Selecciona páginas",
      pdf_drag_to_reorder: "Arrastra las páginas para reordenarlas",
      pdf_signature_label: "Dibuja tu firma",
      pdf_place_on_page: "Página de destino",
      pdf_position_x: "Posición X",
      pdf_position_y: "Posición Y",
      pdf_width: "Ancho",
      pdf_height: "Alto",
      pdf_sign_apply: "Aplicar firma",
      pdf_text_input: "Texto",
      pdf_font_size: "Tamaño",
      // Footer
      footer_made: "Construido para gente que respeta el tiempo.",
      lang_label: "Idioma",
      // Misc
      uploading: "Subiendo…",
      processing: "Procesando…",
      success: "Listo",
      error: "Error",
      file_too_large: "Archivo demasiado grande",
      drop_or_click: "Arrastra y suelta o haz clic para elegir",
      formats_accepted: "Formatos aceptados: PDF, DOCX, XLSX, PPTX, HTML, TXT, MD, JPG, PNG, …",
      target_format: "Formato destino",
      keep_history: "Tu historial está disponible en el panel.",
      // Hero stats
      stat_formats: "formatos soportados",
      stat_tools: "herramientas",
      stat_secure: "tus archivos, tu control",
      stat_templates: "plantillas listas",
      // Landing — DocGen showcase
      docgen_landing_eyebrow: "+100 PLANTILLAS · GENERADOR IA",
      docgen_landing_title_1: "Despidos, contratos, comunicados…",
      docgen_landing_title_2: "todo en segundos.",
      docgen_landing_sub: "Pídele a la IA un documento empresarial en lenguaje natural, o elige entre +100 plantillas legales españolas (RRHH, contratos, legal, finanzas…). Te genera el documento profesional listo para firmar.",
      docgen_landing_bullet_1: "Plantillas conformes con la legislación española (ET, LSC, LAU, RGPD)",
      docgen_landing_bullet_2: "Membrete con tu logo y datos fiscales",
      docgen_landing_bullet_3: "Salida en PDF, Word o ambos",
      docgen_landing_bullet_4: "Asistente paso a paso para contratos complejos",
      docgen_landing_cta: "Empieza gratis 7 días",
      docgen_landing_explore: "Ver el generador",
      docgen_landing_total: "+100 PLANTILLAS LISTAS PARA USAR",
      docgen_cat_rrhh: "RRHH",
      docgen_cat_comunicaciones: "Comunicaciones",
      docgen_cat_contratos: "Contratos",
      docgen_cat_legal: "Legal",
      docgen_cat_comercial: "Comercial",
      docgen_cat_finanzas: "Finanzas",
      docgen_cat_actas: "Actas",
      docgen_cat_cartas: "Cartas",
      // Groups
      group_ai: "01 — IA Studio",
      group_core: "02 — Conversor",
      group_pdf: "03 — Páginas PDF",
      group_privacy: "04 — Privacidad",
      group_share: "05 — Flujos",
      // AI tools
      tool_ai_studio: "AI Document Studio",
      tool_ai_studio_desc: "Chatea con tu PDF, resúmenes, extracción y traducción.",
      tool_natural_command: "Comando natural",
      tool_natural_command_desc: 'Escribe lo que quieres ("extrae 3-5 y firma") y la IA lo ejecuta.',
      tool_ocr: "OCR escaneado",
      tool_ocr_desc: "Reconoce texto en PDFs escaneados (es/en).",
      tool_compress: "Comprimir PDF",
      tool_compress_desc: "Reduce el tamaño manteniendo la calidad útil.",
      tool_protect: "Proteger / Desbloquear",
      tool_protect_desc: "Añade o quita contraseña a un PDF.",
      tool_watermark: "Marca de agua",
      tool_watermark_desc: "Estampa texto diagonal en todas las páginas.",
      tool_redact: "Redactar (ocultar)",
      tool_redact_desc: "Oculta términos sensibles con cajas negras.",
      tool_share_sign: "Enlace de firma",
      tool_share_sign_desc: "Comparte un enlace y deja que firmen sin registrarse.",
      tool_recipes: "Recetas / Pipelines",
      tool_recipes_desc: "Encadena varias operaciones y guárdalas para reutilizar.",
      tool_translate: "Traducir documento",
      tool_translate_desc: "Sube cualquier archivo y recíbelo traducido en el mismo formato.",
      tool_docgen: "Generador de documentos",
      tool_docgen_desc: "Genera despidos, contratos, comunicados y +100 plantillas con IA.",
      tool_scan: "Escanear documento",
      tool_scan_desc: "Haz fotos con la cámara y conviértelas en un PDF (con OCR).",
      // AI Studio UI
      ai_chat_placeholder: "Pregunta lo que quieras sobre el documento…",
      ai_summarize: "Resumir",
      ai_extract: "Extraer datos",
      ai_translate: "Traducir",
      ai_redact_suggest: "Sugerir términos a ocultar",
      ai_target_lang: "Idioma destino",
      ai_no_text: "El documento no tiene texto extraíble. Prueba con OCR primero.",
      ai_chat_title: "Chatea con tu documento",
      ai_thinking: "Pensando…",
      // Natural command
      nc_label: "Tu instrucción",
      nc_placeholder: "Ej: extrae las páginas 3 a 5, añade marca de agua \"BORRADOR\" y conviértelo a Word",
      nc_plan: "Plan generado",
      nc_run: "Ejecutar plan",
      nc_explain: "Explicación",
      // Privacy strings
      compress_level: "Nivel",
      compress_low: "Calidad alta",
      compress_medium: "Equilibrado",
      compress_high: "Tamaño mínimo",
      protect_set: "Establecer contraseña",
      protect_remove: "Quitar contraseña",
      protect_password: "Contraseña",
      watermark_text: "Texto",
      watermark_opacity: "Opacidad",
      redact_terms: "Términos a ocultar (uno por línea)",
      redact_suggest_btn: "Sugerir con IA",
      ocr_lang: "Idioma OCR",
      // Share
      share_create: "Crear enlace",
      share_recipient: "Nombre destinatario",
      share_note: "Nota / mensaje",
      share_link_ready: "Enlace listo",
      share_copy: "Copiar enlace",
      share_pending: "Pendiente",
      share_signed: "Firmado",
      share_revoked: "Revocado",
      share_revoke: "Revocar",
      share_view_signed: "Ver firmado",
      share_my_links: "Mis enlaces",
      share_no_links: "Aún no has creado enlaces.",
      share_public_title: "Te han pedido firmar",
      share_public_signer: "Tu nombre",
      share_public_already_signed: "Este documento ya ha sido firmado.",
      share_public_revoked: "Este enlace ya no es válido.",
      share_public_thanks: "¡Gracias! Tu firma ha sido aplicada.",
      // Pipelines / recipes
      pipeline_steps: "Pasos del pipeline",
      pipeline_add_step: "Añadir paso",
      pipeline_run: "Ejecutar",
      recipe_save: "Guardar como receta",
      recipe_name: "Nombre de la receta",
      recipe_load: "Cargar receta",
      recipe_delete: "Eliminar",
      recipes_empty: "No tienes recetas guardadas.",
      // Misc
      result_ready: "Resultado listo",
      file_loaded: "Archivo listo",
      // Billing / subscription
      nav_billing: "Suscripción",
      billing_pricing_title: "Elige tu plan",
      billing_pricing_sub: "Prueba gratis 7 días, sin tarjeta. Después, mantén el acceso completo.",
      billing_trial_badge: "7 días gratis",
      billing_plan_monthly: "Plan Mensual",
      billing_plan_annual: "Plan Anual",
      billing_save_badge: "Ahorra 40%",
      billing_features_title: "Acceso completo a:",
      billing_feature_1: "Conversiones ilimitadas (PDF, Word, Excel, …)",
      billing_feature_2: "AI Studio (chat, resumen, traducción)",
      billing_feature_3: "Herramientas PDF (firma, OCR, comprimir)",
      billing_feature_4: "Procesamiento por lotes",
      billing_feature_5: "Modo offline + PWA",
      billing_choose: "Elegir este plan",
      billing_processing: "Redirigiendo a pago seguro…",
      billing_status_trialing: "En prueba gratuita",
      billing_status_active: "Suscripción activa",
      billing_status_expired: "Prueba terminada",
      billing_days_left: "{{days}} días restantes",
      billing_active_until: "Activo hasta {{date}}",
      billing_renew: "Renovar acceso",
      billing_my_plan: "Mi suscripción",
      billing_history_title: "Historial de pagos",
      billing_no_history: "Aún no hay pagos.",
      billing_secured_by: "Pagos seguros con Stripe",
      paywall_title: "Tu prueba ha terminado",
      paywall_sub: "Para seguir usando todas las herramientas, suscríbete por solo 6,99 €/mes.",
      paywall_cta: "Ver planes",
      payment_success_title: "¡Pago confirmado!",
      payment_success_sub: "Tu suscripción ya está activa. Disfruta de DocuConvert.",
      payment_pending_title: "Procesando tu pago…",
      payment_pending_sub: "Esto puede tardar unos segundos.",
      payment_failed_title: "El pago no se completó",
      payment_failed_sub: "Inténtalo de nuevo o usa otro método.",
      payment_back_dashboard: "Ir al panel",
      trial_banner: "Te quedan {{days}} días de prueba — ",
      trial_banner_cta: "Suscríbete ahora",
      expired_banner: "Tu prueba ha terminado — ",
      expired_banner_cta: "Reactivar acceso",
      // PayPal billing
      paypal_title: "PAGO SEGURO · PAYPAL",
      paypal_subtitle: "Paga con PayPal",
      paypal_help: "Elige tu plan y completa el pago de forma segura. Cuando termines, te daremos el siguiente paso para activar tu cuenta.",
      paypal_after_title: "DESPUÉS DEL PAGO",
      paypal_after_subtitle: "Activa tu cuenta",
      paypal_after_step1: "Completa el pago con PayPal a la izquierda.",
      paypal_after_step2: "Copia el ID de transacción que PayPal te muestra (también lo recibes por email).",
      paypal_after_step3: "Pégalo en tu página de Suscripción y activamos tu cuenta en menos de 24 h.",
      paypal_go_to_billing: "Ir a Suscripción",
      paypal_pay_annual: "Pagar plan anual",
      billing_awaiting_title: "Hemos recibido tu solicitud",
      billing_awaiting_sub: "Revisamos cada pago manualmente para evitar fraudes. Tu cuenta se activará en menos de 24 horas (normalmente en minutos).",
      billing_claim_eyebrow: "Activar tras pago",
      billing_claim_title: "He pagado, activa mi cuenta",
      billing_claim_help: "Si ya has pagado en PayPal, pégalo aquí: nos llegará tu solicitud y activamos tu cuenta tras verificar la transacción.",
      billing_claim_plan: "¿Qué plan has pagado?",
      billing_claim_txn: "ID de transacción de PayPal",
      billing_claim_txn_placeholder: "Ej: 9AB12345CD678901E",
      billing_claim_note_optional: "Notas (opcional)",
      billing_claim_note_placeholder: "Cualquier información adicional sobre tu pago...",
      billing_claim_submit: "Enviar solicitud",
      billing_claim_submitting: "Enviando…",
      billing_claim_submitted: "¡Solicitud enviada! Te avisaremos cuando se active.",
      billing_req_txn_empty: "Pega el ID de transacción de PayPal",
      billing_req_submitted: "Solicitud enviada. Te activaremos pronto.",
      billing_history: "Historial",
      billing_req_pending: "PENDIENTE",
      billing_req_approved: "ACTIVA",
      billing_req_rejected: "RECHAZADA",
    },
  },
  en: {
    translation: {
      brand: "DocuConvert",
      tagline: "Convert and sign documents — no excuses.",
      hero_eyebrow: "Document platform",
      hero_title_1: "Any format.",
      hero_title_2: "Any direction.",
      hero_sub:
        "PDF, Word, Excel, PowerPoint, HTML, images and more. Convert, merge, split and sign in seconds. Your files, your control.",
      cta_start: "Start free",
      cta_login: "Sign in",
      cta_register: "Create account",
      cta_logout: "Sign out",
      cta_dashboard: "Dashboard",
      cta_download: "Download",
      cta_delete: "Delete",
      cta_continue: "Continue",
      cta_convert: "Convert",
      cta_back: "Back",
      cta_choose_file: "Choose file",
      cta_choose_files: "Choose files",
      cta_drop_here: "Drop file here",
      cta_clear: "Clear",
      cta_save: "Save",
      cta_apply: "Apply",
      nav_tools: "Tools",
      nav_convert: "Convert",
      nav_pdf: "PDF Tools",
      nav_dashboard: "Dashboard",
      tools_title: "Tools",
      tools_subtitle: "Every operation you need in one place.",
      tool_convert: "Convert document",
      tool_convert_desc: "Switch between PDF, Word, Excel, HTML, images and more.",
      tool_merge: "Merge PDFs",
      tool_merge_desc: "Join multiple PDFs into a single file in order.",
      tool_split: "Split PDF",
      tool_split_desc: "Break a PDF into one page per file.",
      tool_extract: "Extract pages",
      tool_extract_desc: "Pick specific pages and save them as a new PDF.",
      tool_reorder: "Reorder pages",
      tool_reorder_desc: "Drag and reorganize pages inside a PDF.",
      tool_sign: "Sign PDF",
      tool_sign_desc: "Draw your signature and place it on any page.",
      tool_annotate: "Add text",
      tool_annotate_desc: "Insert text annotations at any coordinate.",
      auth_login_title: "Welcome back",
      auth_login_sub: "Sign in to manage your documents.",
      auth_register_title: "Create your account",
      auth_register_sub: "No card. No spam. Just tools.",
      auth_email: "Email",
      auth_password: "Password",
      auth_name: "Name",
      auth_no_account: "No account yet?",
      auth_have_account: "Already have an account?",
      auth_loading: "Loading…",
      dashboard_title: "My documents",
      dashboard_subtitle: "History of uploads and generated outputs.",
      dashboard_empty: "No files yet. Start by converting or using a tool.",
      th_name: "Name",
      th_kind: "Kind",
      th_op: "Operation",
      th_size: "Size",
      th_date: "Date",
      th_actions: "Actions",
      kind_upload: "Upload",
      kind_converted: "Converted",
      kind_tool_output: "Output",
      convert_title: "Universal converter",
      convert_subtitle: "Pick a file and the destination format.",
      convert_target: "Convert to",
      convert_done: "Conversion ready",
      pdf_pages_loading: "Loading pages…",
      pdf_select_pages: "Select pages",
      pdf_drag_to_reorder: "Drag pages to reorder",
      pdf_signature_label: "Draw your signature",
      pdf_place_on_page: "Target page",
      pdf_position_x: "X position",
      pdf_position_y: "Y position",
      pdf_width: "Width",
      pdf_height: "Height",
      pdf_sign_apply: "Apply signature",
      pdf_text_input: "Text",
      pdf_font_size: "Size",
      footer_made: "Built for people who respect time.",
      lang_label: "Language",
      uploading: "Uploading…",
      processing: "Processing…",
      success: "Done",
      error: "Error",
      file_too_large: "File too large",
      drop_or_click: "Drag & drop or click to choose",
      formats_accepted: "Accepted: PDF, DOCX, XLSX, PPTX, HTML, TXT, MD, JPG, PNG, …",
      target_format: "Target format",
      keep_history: "Your history is available in the dashboard.",
      stat_formats: "supported formats",
      stat_tools: "tools",
      stat_secure: "your files, your control",
      stat_templates: "ready templates",
      docgen_landing_eyebrow: "100+ TEMPLATES · AI GENERATOR",
      docgen_landing_title_1: "Dismissals, contracts, memos…",
      docgen_landing_title_2: "in seconds.",
      docgen_landing_sub: "Ask AI for a business document in natural language, or pick from 100+ Spanish legal templates (HR, contracts, legal, finance…). Get a professional document ready to sign.",
      docgen_landing_bullet_1: "Templates compliant with Spanish law (ET, LSC, LAU, GDPR)",
      docgen_landing_bullet_2: "Header with your logo and tax details",
      docgen_landing_bullet_3: "Output in PDF, Word, or both",
      docgen_landing_bullet_4: "Step-by-step wizard for complex contracts",
      docgen_landing_cta: "Start 7-day free trial",
      docgen_landing_explore: "See the generator",
      docgen_landing_total: "100+ READY-TO-USE TEMPLATES",
      docgen_cat_rrhh: "HR",
      docgen_cat_comunicaciones: "Communications",
      docgen_cat_contratos: "Contracts",
      docgen_cat_legal: "Legal",
      docgen_cat_comercial: "Sales",
      docgen_cat_finanzas: "Finance",
      docgen_cat_actas: "Minutes",
      docgen_cat_cartas: "Letters",
      group_ai: "01 — AI Studio",
      group_core: "02 — Converter",
      group_pdf: "03 — PDF Pages",
      group_privacy: "04 — Privacy",
      group_share: "05 — Flows",
      tool_ai_studio: "AI Document Studio",
      tool_ai_studio_desc: "Chat with your PDF, summarize, extract and translate.",
      tool_natural_command: "Natural command",
      tool_natural_command_desc: 'Type what you want ("extract 3-5 and sign") — AI does it.',
      tool_ocr: "OCR scanned",
      tool_ocr_desc: "Recognize text in scanned PDFs (es/en).",
      tool_compress: "Compress PDF",
      tool_compress_desc: "Reduce file size while keeping usable quality.",
      tool_protect: "Protect / Unlock",
      tool_protect_desc: "Add or remove a password from a PDF.",
      tool_watermark: "Watermark",
      tool_watermark_desc: "Stamp diagonal text across every page.",
      tool_redact: "Redact",
      tool_redact_desc: "Hide sensitive terms with black boxes.",
      tool_share_sign: "Sign link",
      tool_share_sign_desc: "Share a link and let others sign without signing up.",
      tool_recipes: "Recipes / Pipelines",
      tool_recipes_desc: "Chain operations and save them to reuse.",
      tool_translate: "Translate document",
      tool_translate_desc: "Upload any file and get it translated keeping the same format.",
      tool_docgen: "Document generator",
      tool_docgen_desc: "AI-generated dismissals, contracts, memos and 100+ templates.",
      tool_scan: "Scan document",
      tool_scan_desc: "Snap photos with the camera and merge them into a PDF (with OCR).",
      ai_chat_placeholder: "Ask anything about the document…",
      ai_summarize: "Summarize",
      ai_extract: "Extract data",
      ai_translate: "Translate",
      ai_redact_suggest: "Suggest terms to redact",
      ai_target_lang: "Target language",
      ai_no_text: "The document has no extractable text. Try OCR first.",
      ai_chat_title: "Chat with your document",
      ai_thinking: "Thinking…",
      nc_label: "Your instruction",
      nc_placeholder: "e.g. extract pages 3 to 5, add a 'DRAFT' watermark and convert to Word",
      nc_plan: "Generated plan",
      nc_run: "Run plan",
      nc_explain: "Explanation",
      compress_level: "Level",
      compress_low: "High quality",
      compress_medium: "Balanced",
      compress_high: "Smallest size",
      protect_set: "Set password",
      protect_remove: "Remove password",
      protect_password: "Password",
      watermark_text: "Text",
      watermark_opacity: "Opacity",
      redact_terms: "Terms to hide (one per line)",
      redact_suggest_btn: "Suggest with AI",
      ocr_lang: "OCR language",
      share_create: "Create link",
      share_recipient: "Recipient name",
      share_note: "Note / message",
      share_link_ready: "Link ready",
      share_copy: "Copy link",
      share_pending: "Pending",
      share_signed: "Signed",
      share_revoked: "Revoked",
      share_revoke: "Revoke",
      share_view_signed: "View signed",
      share_my_links: "My links",
      share_no_links: "No links yet.",
      share_public_title: "You've been asked to sign",
      share_public_signer: "Your name",
      share_public_already_signed: "This document has already been signed.",
      share_public_revoked: "This link is no longer valid.",
      share_public_thanks: "Thank you! Your signature was applied.",
      pipeline_steps: "Pipeline steps",
      pipeline_add_step: "Add step",
      pipeline_run: "Run",
      recipe_save: "Save as recipe",
      recipe_name: "Recipe name",
      recipe_load: "Load recipe",
      recipe_delete: "Delete",
      recipes_empty: "No saved recipes yet.",
      result_ready: "Result ready",
      file_loaded: "File ready",
      // Billing / subscription
      nav_billing: "Subscription",
      billing_pricing_title: "Choose your plan",
      billing_pricing_sub: "7-day free trial, no card required. Keep full access after.",
      billing_trial_badge: "7 days free",
      billing_plan_monthly: "Monthly plan",
      billing_plan_annual: "Annual plan",
      billing_save_badge: "Save 40%",
      billing_features_title: "Full access to:",
      billing_feature_1: "Unlimited conversions (PDF, Word, Excel, …)",
      billing_feature_2: "AI Studio (chat, summary, translate)",
      billing_feature_3: "PDF tools (sign, OCR, compress)",
      billing_feature_4: "Batch processing",
      billing_feature_5: "Offline mode + PWA",
      billing_choose: "Choose this plan",
      billing_processing: "Redirecting to secure checkout…",
      billing_status_trialing: "Free trial",
      billing_status_active: "Active subscription",
      billing_status_expired: "Trial ended",
      billing_days_left: "{{days}} days remaining",
      billing_active_until: "Active until {{date}}",
      billing_renew: "Renew access",
      billing_my_plan: "My subscription",
      billing_history_title: "Payment history",
      billing_no_history: "No payments yet.",
      billing_secured_by: "Secure payments by Stripe",
      paywall_title: "Your trial has ended",
      paywall_sub: "To keep using every tool, subscribe for just €6.99/month.",
      paywall_cta: "See plans",
      payment_success_title: "Payment confirmed!",
      payment_success_sub: "Your subscription is now active. Enjoy DocuConvert.",
      payment_pending_title: "Processing your payment…",
      payment_pending_sub: "This may take a few seconds.",
      payment_failed_title: "Payment not completed",
      payment_failed_sub: "Try again or use another method.",
      payment_back_dashboard: "Back to dashboard",
      trial_banner: "{{days}} days left in your trial — ",
      trial_banner_cta: "Subscribe now",
      expired_banner: "Your trial has ended — ",
      expired_banner_cta: "Reactivate access",
      paypal_title: "SECURE PAYMENT · PAYPAL",
      paypal_subtitle: "Pay with PayPal",
      paypal_help: "Pick your plan and pay securely. After payment, we'll guide you to activate your account.",
      paypal_after_title: "AFTER PAYMENT",
      paypal_after_subtitle: "Activate your account",
      paypal_after_step1: "Complete the payment with PayPal on the left.",
      paypal_after_step2: "Copy the transaction ID PayPal shows you (also sent by email).",
      paypal_after_step3: "Paste it on your Subscription page and we'll activate your account within 24 hours.",
      paypal_go_to_billing: "Go to Subscription",
      paypal_pay_annual: "Pay annual plan",
      billing_awaiting_title: "We received your request",
      billing_awaiting_sub: "We review each payment manually to prevent fraud. Your account will activate within 24h (usually in minutes).",
      billing_claim_eyebrow: "Activate after payment",
      billing_claim_title: "I paid, activate my account",
      billing_claim_help: "If you already paid through PayPal, paste the transaction ID below — we'll verify and activate your account.",
      billing_claim_plan: "Which plan did you pay?",
      billing_claim_txn: "PayPal transaction ID",
      billing_claim_txn_placeholder: "e.g.: 9AB12345CD678901E",
      billing_claim_note_optional: "Notes (optional)",
      billing_claim_note_placeholder: "Any extra info about your payment...",
      billing_claim_submit: "Submit request",
      billing_claim_submitting: "Submitting…",
      billing_claim_submitted: "Request submitted!",
      billing_req_txn_empty: "Paste the PayPal transaction ID",
      billing_req_submitted: "Request submitted. We'll activate you soon.",
      billing_history: "History",
      billing_req_pending: "PENDING",
      billing_req_approved: "ACTIVE",
      billing_req_rejected: "REJECTED",
    },
  },
};

const stored = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
i18n.use(initReactI18next).init({
  resources,
  lng: stored || "es",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
